import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const InputValidIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path
      fillRule="evenodd"
      d="m12.416 4.277-5.672 8.508-3.098-3.098.708-.707 2.235 2.235 4.995-7.492.832.554Z"
    />
  </IconWrapper>
)

export default InputValidIconSmall
